export var extractNumericDataAttribute = function extractNumericDataAttribute(event, name) {
  var value = parseInt(event.currentTarget.getAttribute("data-".concat(name)), 10);

  if (value === null || value === undefined || Number.isNaN(value)) {
    return null;
  }

  return value;
};